import { AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import { Totem } from "../../../@types/totem";
import { apisiseci } from "../../api";

export function useTotemDetails(id: Totem["id"]) {
    const token = localStorage.getItem("gov_access_token_sso");

    return useQuery<Totem, AxiosError<{ detail: string }>>({
        enabled: !!token,
        queryKey: ['totem', 'details', id],
        queryFn: async () => {
            const response = await apisiseci.get<Totem>(
                `/cms/totens/${id}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
    });
}
